// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"617e11f2","690":"a1aeb862","972":"00a9ac38"}[chunkId] + ".chunk.css";
};